import { SizableText, YStack } from '@mythical/ui'
import { RainbowHero as RainbowHeroType } from 'app/blocks/landing/rainbow-hero'
import { ButtonLink } from 'app/components/primitive/Button'
import { Container } from 'app/components/structure/Container'
import { useStores } from 'app/store'
import { SolitoImage } from 'solito/image'

const rainbow = require('app/assets/svg/rainbow.svg') as string

const RainbowHero = ({
  title,
  subtitle,
  ctaLabel,
  ctaLink,
}: RainbowHeroType) => {
  const { userStore } = useStores()
  const canMemberfulLink = userStore?.canMemberfulLink ?? false
  return (
    <Container
      bg="$bgInverted"
      br="$5"
      mx="auto"
      overflow="hidden"
      position="relative"
      variant="full"
      $gtSm={{ minHeight: 752 }}
    >
      <YStack
        aspectRatio={79 / 94}
        overflow="hidden"
        rotate="90deg"
        w="100%"
        $gtSm={{ display: 'none' }}
      >
        <SolitoImage alt="" src={rainbow} fill contentFit="contain" />
      </YStack>

      <YStack
        aspectRatio={79 / 94}
        bottom={0}
        display="none"
        position="absolute"
        right={95}
        top={0}
        $gtSm={{ display: 'flex' }}
      >
        <SolitoImage alt="" src={rainbow} fill contentFit="contain" />
      </YStack>

      <YStack
        f={1}
        gap="$7"
        jc="flex-end"
        pb="$7"
        px="$3.5"
        $gtSm={{
          jc: 'space-between',
          px: '$14',
          py: '$12',
        }}
        $gtLg={{
          maw: '75%',
        }}
      >
        <YStack gap="$5">
          <SizableText
            ff="$display"
            size="$xl"
            fontWeight="700"
            col="$fgInverted"
            tt="uppercase"
            $gtSm={{ size: '$11.5', fontWeight: '700' }}
          >
            {title}
          </SizableText>

          <SizableText
            col="$fgInverted"
            fontWeight="500"
            $gtSm={{ size: '$xl', fontWeight: '500' }}
            $gtLg={{ maw: '67%' }}
          >
            {subtitle}
          </SizableText>
        </YStack>

        {canMemberfulLink && (
          <ButtonLink
            href={ctaLink}
            mx="auto"
            size="$5"
            textProps={{
              size: '$l',
              fontWeight: '500',
              $gtSm: {
                size: '$xl',
                fontWeight: '500',
              },
            }}
            $gtSm={{
              mx: 0,
              mr: 'auto',
            }}
          >
            {ctaLabel}
          </ButtonLink>
        )}
      </YStack>
    </Container>
  )
}

export default RainbowHero
